import { GenericObject } from "utility/misc";

export default function redirectToGCPConnectPage(
  orgStore: GenericObject,
  navigate: Function
): void {
  navigate("/environment/sources/gcp/connect");
}
